import { render, staticRenderFns } from "./openPayPage.vue?vue&type=template&id=638316af&"
import script from "@viewJs/examRegisteation/openPayPage.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/openPayPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports